import React, { Component } from 'react';
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { findDOMNode } from 'react-dom';
import style from '../modals/ImageUploadModal/style.scss';
import ChevronLeftCircleIcon from '../../../../../../travelerProfile/components/icons/ChevronLeftCircleIcon';
import ChevronRightCircleIcon from '../../../../../../travelerProfile/components/icons/ChevronRightCircleIcon';
import DragAndDropIcon from '../../../../../../travelerProfile/components/icons/DragAndDropIcon';
import CircleTickIcon from '../../../../../../travelerProfile/components/icons/CircleTickIcon';
import GearIcon from '../../../../../../travelerProfile/components/icons/GearIcon';

import { DragSource, DropTarget } from 'react-dnd';
import UnsplashIcon from '../../../../../../travelerProfile/components/icons/UnsplashIcon';

export const enhance = compose(withStyles(style));

const cardSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.moveCard(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

@DropTarget('OPTION', cardTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('OPTION', cardSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
class ImageCardV2 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isDragging,
      connectDragSource,
      connectDropTarget,
      index,
      totalFiles,
      moveCard,
      selectedImageIds,
      file,
      handleSelectedImage,
      handleShowDescModal
    } = this.props;

    const cardContent = (
      <div>
        <div
          className={`${style.uploadedImage} ${
            selectedImageIds.find(item => item === file?.id) ? style.imageWrapperSelected : ''
          }`}
        >
          <div className={style.imageHeader}>
            <div className={style.leftHeader}>
              {selectedImageIds.find(item => item === file.id) && 
                <div><CircleTickIcon /></div> 
              }
              <div>
                <button
                  type="button"
                  className={style.noBorderButton}
                  onClick={() => handleShowDescModal(true)}
                >
                <GearIcon color="#255A94" width='18px' height='18px' />
                </button>
              </div>
            </div>
            <div className={style.rightHeader}>
              <button
                type="button"
                className={style.noBorderButton}
                disabled={index === 0 ? true : false}
                onClick={() => moveCard(index, index - 1)}
              >
                <ChevronLeftCircleIcon color={index === 0 ? '#999999' : '#373737'} />
              </button>
              <button
                type="button"
                className={style.noBorderButton}
                disabled={totalFiles === index + 1 ? true : false}
                onClick={() => moveCard(index, index + 1)}
              >
                <ChevronRightCircleIcon color={totalFiles === index + 1 ? '#999999' : '#373737'} />
              </button>
              <DragAndDropIcon />
            </div>
          </div>
          <div className={style.uploadedImageContainer} onClick={() => handleSelectedImage(file.id)}>
            <img src={file?.unsplash_image ? file?.unsplash_url : file?.s3_store} />
          </div>
          {file?.unsplash_image ? (
            <div className={style.imageNameContainer}>
              <UnsplashIcon color={'#666666'} />
              <div className={style.imageName}>Unsplash</div>
            </div>
          ) : (
            <div className={style.imageName}>{file?.file_name}</div>
          )}
        </div>
      </div>
    );

    return connectDragSource(connectDropTarget(cardContent));
  }
}

export default ImageCardV2;
